import { render } from "./JoinCodeBox.vue?vue&type=template&id=27478ee3"
import script from "./JoinCodeBox.vue?vue&type=script&lang=js"
export * from "./JoinCodeBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__